import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route
          path={`${APP_PREFIX_PATH}/vouchers`}
          component={lazy(() => import(`./vouchers`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/partnership`}
          component={lazy(() => import(`./partnership`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/partner-client`}
          component={lazy(() => import(`./partnerClient`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/home`}
          component={lazy(() => import(`./home`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/gift-vouchers`}
          component={lazy(() => import(`./giftVouchers`))}
        />
        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/home`} />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
